// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3Qopd","file":"styles_file__3qzJw"};